import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from 'src/checkout/components/CheckoutDescription/CheckoutDescription';
import { FormikTokenInput } from 'src/general/components/forms/FormikTokenInput/FormikTokenInput';

import styles from './PersonalizedQuoteForm.module.scss';
import { PersonalizedQuoteFormProps, VerificationTokenFormValues } from './PersonalizedQuoteForm.type';

const timerLength = 30;
const inputLength = 4;

const initialValues: VerificationTokenFormValues = {
  verificationCode: '0000',
};

export const VerificationTokenForm: FC<
  PersonalizedQuoteFormProps<VerificationTokenFormValues> & {
    phone: string;
    onResendTokenVerificationCode: () => Promise<void>;
  }
> = ({ onSubmit, values, onBack, phone, onResendTokenVerificationCode }) => (
  <>
    <CheckoutDescription
      title="Enter verification code"
      description={
        <>
          We have sent a code to <b>{phone}</b>. This can take up to 2 minutes to receive
        </>
      }
      onBack={onBack}
    />
    <div className={styles.verifyTokenForm}>
      <Formik initialValues={{ ...initialValues, ...values }} validateOnChange={false} onSubmit={onSubmit}>
        {(props) => (
          <Form className={styles.form} noValidate>
            <FormikTokenInput
              isDisabled={props.isSubmitting}
              invalidTokenMessage={props.errors.verificationCode}
              onChange={(val) => {
                props.setFieldValue('verificationCode', val);
              }}
              onResendTokenVerificationCode={onResendTokenVerificationCode}
              onSubmit={props.submitForm}
              timerLength={timerLength}
              inputLength={inputLength}
            />
          </Form>
        )}
      </Formik>
    </div>
  </>
);
